export default function About() {
  return (
    <section id="about" className="w-full py-14 md:py-18 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="mb-8 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            关于午马
          </h2>
          <p className="text-foreground-600 text-sm mt-2">了解午马影院的初心与坚持</p>
        </div>

        <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/60">
          <div className="prose max-w-none">
            <p className="text-foreground-700 leading-relaxed text-sm md:text-base mb-4">
              午马影院创立于对影视热爱的初心——我们希望为每一位影迷打造一个纯净、流畅、免费的高清在线观影平台。
            </p>
            <p className="text-foreground-700 leading-relaxed text-sm md:text-base mb-4">
              平台汇聚了超过<strong>30000部</strong>影视资源，从最新院线大片到经典老片，从热播电视剧到人气动漫，从高分纪录片到精彩综艺，用心整理每一个专题合集，让您轻松发现好内容。
            </p>
            <p className="text-foreground-700 leading-relaxed text-sm md:text-base mb-4">
              我们深知等待缓冲的痛苦——因此投入大量技术资源优化播放体验，采用智能多线路调度和CDN加速技术，确保<strong>高清画质下流畅不卡顿</strong>。无需注册、无需付费、即点即播，这是我们对每一位用户的承诺。
            </p>
            <p className="text-foreground-700 leading-relaxed text-sm md:text-base">
              午马影院团队<strong>每日更新200+部</strong>资源，第一时间跟进院线新片和热门剧集。我们相信，好的影视内容应该被更多人看到，而好的观影体验不应该有门槛。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-6 border-t border-background-200/60">
            <div className="text-center">
              <div className="text-2xl font-bold text-primary-600 font-heading">30000+</div>
              <div className="text-xs text-foreground-500 mt-1">影视资源</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-accent-600 font-heading">200+</div>
              <div className="text-xs text-foreground-500 mt-1">日更新量</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-primary-600 font-heading">4K</div>
              <div className="text-xs text-foreground-500 mt-1">最高画质</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-accent-600 font-heading">0</div>
              <div className="text-xs text-foreground-500 mt-1">注册门槛</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}